import React from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '../../store/applicationStore';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';

export const DemoButton = observer(() => {
  const t = useTranslation();
  return (
    <div
      className='pgc-play-for-real-btn-holder'
      onClick={applicationStore.demoSwitcher.bind(applicationStore)}
    >
      <button className='pgc-play-for-real-btn' title='Play for real'>
        {t(TranslationKeys.PLayForReal)}
      </button>
    </div>
  );
});
